const homeAudiencesPath = '/app/audiences';
const homePath = '/app/dashboard';

export { homeAudiencesPath, homePath };
